import { useLayoutEffect, useState } from 'react';
import { useResizeObserver } from './useResizeObserver';
export var useHasOverflowX = _ref => {
  var _ref$current;

  var {
    ref
  } = _ref;
  var {
    width
  } = useResizeObserver({
    ref
  });
  var [hasOverflow, setHasOverflow] = useState(false);
  useLayoutEffect(() => {
    if (!ref.current) return;
    setHasOverflow(ref.current.scrollWidth > ref.current.clientWidth); // We need to track `clientWidth` as it may change after first render.
  }, [ref, (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.clientWidth, width]);
  return hasOverflow;
};
//# sourceMappingURL=useHasOverflowX.js.map